import { Component } from '@angular/core';

@Component({
    selector: 'app-circle-warn',
    template: `
        <app-custom-circle-icon color="warning-color">
            <i class="material-icons" icon>warning</i>
        </app-custom-circle-icon>
    `,
})
export class CircleWarnComponent {}
